// Order status filter chips, shared by every console's Orders tab.
//
// The groups are the ones the ops Orders tab (and, through it, sales) and the legacy
// /all-orders table (src/components/orderTable/orders.jsx) have always shown -- same
// labels, same status sets, same order -- so "Ready to Ship" means the same rows on every
// console, plus "Order Packed" (2026-10-27). The legacy copy is left where it is and does
// not have that chip; ops reads this one.
//
// Each chip is a SET of raw userOrders.status values; selecting several chips ORs their
// sets, which GET /userOrder/admin takes as one comma-joined `status` param.
//
// Not every status has a chip: ORDER_CONFIRMED, PAYMENT_CONFIRMED, ORDER_PROCURED,
// ORDER_DRX_CREATED, ORDER_DRX_SENT, SHIPPED_PACKAGING, SHIPPED_BOX_PACKED,
// SHIPPED_VIA_PILLUP, SHIPPED_VIA_ZYDUS and the confirmRX_* pair are valid statuses the
// existing chips never covered. Kept identical to ops on purpose; extending the groups is
// a product call that should change every console at once, here.
export const ORDER_STATUS_FILTERS = [
    {
        id: "pending",
        label: "Order Pending",
        statuses: ["ORDER_PENDING", "ORDER_INACTIVE", "ORDER_UPLOADRX", "CALL_PENDING", "CALL_PICKED", "RX_SENT", "RX_SEND"],
    },
    { id: "confirmed", label: "Order Confirmed", statuses: ["ORDER_ACTIVE"] },
    { id: "cancelled", label: "Order Cancelled", statuses: ["ORDER_CANCELLED"] },
    { id: "payment_pending", label: "Payment Pending", statuses: ["CONSENT_GRANTED", "PAYMENT_PENDING"] },
    { id: "payment_success", label: "Payment Success", statuses: ["PAYMENT_SUCCESS"] },
    { id: "ocs_pending", label: "OCS Pending", statuses: ["OCS_PENDING", "OCS_PROCESSING"] },
    { id: "drx_to_confirm", label: "DRX To Be Cofirmed", statuses: ["USER_DRX_PENDING"] },
    { id: "consent_pending", label: "Consent Pending", statuses: ["USER_DRX_ACCEPTED", "CONSENT_PENDING"] },
    // What "Mark as Packed" sets (pillup-api classes/UserOrder/Functions.js markOrderAsPacked).
    // Added on its own so packed orders can be picked out; Ready to Ship below is left as
    // it always was and still includes them, so its counts do not change.
    { id: "packed", label: "Order Packed", statuses: ["SHIPPED_MEDICINES_PACKED"] },
    { id: "ready_to_ship", label: "Ready to Ship", statuses: ["SHIPPED_MEDICINES_PACKED", "MDM_QC", "SHIPPED_READY_TO_SHIP"] },
    { id: "in_transit", label: "In Transit", statuses: ["SHIPPED_IN_TRANSIT"] },
    { id: "delivered", label: "Delivered", statuses: ["DELIVERED"] },
    { id: "needs_attention", label: "Needs Attention", statuses: ["SHIPPED_ERROR", "USER_DRX_REJECTED"] },
];

const BY_ID = new Map(ORDER_STATUS_FILTERS.map((filter) => [filter.id, filter]));

/** Chip ids from a `?status=a,b` URL value, dropping anything unknown. */
export function parseStatusFilterParam(value) {
    return String(value || "")
        .split(",")
        .map((id) => id.trim())
        .filter((id) => BY_ID.has(id));
}

/** The raw statuses selected chip ids stand for, de-duplicated. */
export function statusesForFilters(ids) {
    const out = new Set();
    (ids || []).forEach((id) => (BY_ID.get(id)?.statuses || []).forEach((status) => out.add(status)));
    return [...out];
}
